import React from "react";
import { WarningOctagon, XCircle } from "@phosphor-icons/react";
import { isPaidCancellation, cancellationShortLabel } from "@/lib/orderCancellation";

/**
 * Small pill rendered on order list/cards when status === "cancelled".
 * Switches copy + intensity based on whether a refund is owed.
 */
export default function CancelledPill({ order, className = "" }) {
  const label = cancellationShortLabel(order);
  if (!label) return null;
  const refund = isPaidCancellation(order);
  return (
    <span
      data-testid={`cancelled-pill-${order.order_number || order.id}`}
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] font-black rounded-md px-2 py-1 border whitespace-nowrap ${
        refund
          ? "bg-red-600 text-white border-red-700"
          : "bg-red-100 text-red-800 border-red-300 dark:bg-red-950/40 dark:text-red-300 dark:border-red-800"
      } ${className}`}
      title={refund ? "Refund needed — payment already taken" : "Order cancelled upstream"}
    >
      {refund ? <WarningOctagon size={11} weight="fill" /> : <XCircle size={11} weight="fill" />}
      {label}
    </span>
  );
}
